import React, { useMemo } from 'react';

import Step from 'components/Misc/Pages/Step';

// Pagination wrap
// @progress: boolean | collection progress state
// @active: number | current page
// @total: number | collection size
// @onPage: function | onClick handler
const Pagination = ({ progress, active, total, size = 24, onChange, className }) => {
	// Calculate pagination offsets
	const offset = useMemo(() => {
		const start = (active * size) - (size - 1);
		return {
			start,
			end: Math.min(start + size - 1, total)
		};
	}, [active, size, total]);

	// Calculate disabled states
	const disabled = useMemo(() => {
		return {
			start: active === 1,
			end: offset.end === total
		};
	}, [offset, total, active]);

	return (
		<div className="flex justify-end items-center">
			<div className="mr-2 text-sm text-neutral-700 dark:text-neutral-500">
				Rāda {offset.start > total ? total : offset.start}-{offset.end} no {total} rezulātiem
			</div>

			{/* Step one page backwards */}
			<Step
				icon="chevron_left"
				disabled={disabled.start}
				active={active}
				action="prev"
				onChange={onChange}
			/>

			{/* Step one page forwards */}
			<Step
				icon="chevron_right"
				disabled={disabled.end}
				active={active}
				action="next"
				onChange={onChange}
			/>
		</div>
	);
};

export default Pagination;
